import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Message from "../../enums/Message";
import _ from "lodash";
import {graphql} from "react-apollo/lib/index";
import UpdateIgnoreLabelMutation from "../../graphql/UpdateIgnoreLabelMutation.graphql";
import ImportButton from "./ImportButton";

@graphql(
	UpdateIgnoreLabelMutation, {
		name: 'updateIgnoredLabel'
	}
)
export default class NotFoundLabels extends Component {
	constructor(prop) {
		super(prop);

		this.state = {
			selectedLabels: [],
			defaultLanguage: ""
		};
	}

	static propTypes = {
		status: PropTypes.object,
		data: PropTypes.object,
		selectedProject: PropTypes.object,
	};

	selectAllNotFound = (event) => {
		var notFoundLabels = [];
		if (event.target.checked)
		{
			_.map(this.props.data.project.codeScan.notFoundLabels, (notFoundLabel) => {
				if (!notFoundLabel.label.ignoreforscan){
					notFoundLabels.push(notFoundLabel.label.identifier)
				}
			})
		}
		this.setState({
			selectedLabels: notFoundLabels
		})
	};



	updateNotFoundLabelsSelection = (event) => {
		var selectedLabelsCopy = this.state.selectedLabels
		if (event.target.checked)
		{
			selectedLabelsCopy.push(event.target.id)
		}else {
			selectedLabelsCopy.splice(selectedLabelsCopy.indexOf(event.target.id), 1)
		}
		this.setState({
			selectedLabels: selectedLabelsCopy
		})
	}

	toggleIgnoreLabel(label, key) {
		const newStatus = !label.ignoreforscan;
		const newNotFoundLabels = [...this.props.data.project.codeScan.notFoundLabels];
		newNotFoundLabels[key].label.ignoreforscan = newStatus;

		this.setState({
			notFoundLabels: newNotFoundLabels
		});

		this.props.updateIgnoredLabel({
			variables: {
				input: {
				    projectName: this.props.selectedProject.name,
					identifier: label.labelCollection.identifier,
					name: label.name,
					value: newStatus
				}
			}
		}).then(
			result => {

			},
			error => {
				this.props.addMessage(new Message(
					Message.TYPE_ERROR,
					500,
					'Could not update Label: ' + error.message
				));
			}
		)
	}

	render() {
		const {status, data} = this.props;

		return (
			<div className="tab-pane" id="messages" role="tabpanel" aria-expanded="false">
				<div className="table-responsive">
					<table className="table">
						<thead className="">
						<tr>
							<th>
								<div className="form-check xpull-left">
									<label className="form-check-label">
										<input type="checkbox" id="notFoundNotIgnored" value=""
											   onChange={this.selectAllNotFound}/>
										<span className="form-check-sign"/>
									</label>
								</div>

							</th>
							<th>Ignore</th>
							<th>
								Collection
							</th>
							<th>
								id
							</th>
							<th>
								default
							</th>
							{_.map(data.project.languages, (language, key) => {
								return (
									<th key={key}>{language.identifier}</th>
								)
							})}
						</tr>
						</thead>
						<tbody>
						{_.map(data.project.codeScan.notFoundLabels, (notFoundLabel, key) => {
							if (!notFoundLabel.label.ignoreforscan) {
								return (
									<tr key={key}>
										<td>
											<div className="form-check xpull-left">
												<label className="form-check-label">
													<input name="notFoundNotIgnored" type="checkbox"
														   id={notFoundLabel.label.identifier}
														   checked={this.state.selectedLabels.includes(notFoundLabel.label.identifier)}
														   onChange={this.updateNotFoundLabelsSelection}/>
													<span className="form-check-sign"/>
												</label>
											</div>

										</td>
										<td>
											<button className="btn btn-outline-default btn-round btn-icon"
													disabled={status.project.codeScan.isRunning}
													onClick={() => this.toggleIgnoreLabel(notFoundLabel.label, key)}>
																<span className="btn-label">
																	<i className="nc-icon nc-lock-circle-open"></i>
															  	</span>
											</button>
										</td>
										<td>
											<small title={notFoundLabel.label.labelCollection.identifier}>{notFoundLabel.label.labelCollection.identifier.split(':').splice(-1)}</small>
										</td>
										<td>{notFoundLabel.label.name}</td>
										<td>{notFoundLabel.label.defaultValue}</td>
										{_.map(data.project.languages, (language, key) => {
											let value = '';
											_.map(notFoundLabel.label.translations, (translation) => {
												if (translation.labelcollectionlanguage.language.identifier === language.identifier) {
													value = translation.value;
												}
											});
											return (<td key={key}>{value}</td>)
										})}
									</tr>
								)
							}
						})}
						</tbody>
					</table>
					<h3>Ignored:</h3>
					<table className="table">
						<thead className="">
						<tr>
							<th>Ignore</th>
							<th>
								Collection
							</th>
							<th>
								id
							</th>
							<th>
								default
							</th>
							{_.map(data.project.languages, (language, key) => {
								return (
									<th key={key}>{language.identifier}</th>
								)
							})}
						</tr>
						</thead>
						<tbody>
						{_.map(data.project.codeScan.notFoundLabels, (notFoundLabel, key) => {
							if (notFoundLabel.label.ignoreforscan) {
								return (
									<tr key={key}>
										<td>
											<button className="btn btn-outline-default btn-round btn-icon"
													disabled={status.project.codeScan.isRunning}
													onClick={() => this.toggleIgnoreLabel(notFoundLabel.label, key)}>
																<span className="btn-label">
																	<i className="nc-icon nc-lock-circle-open"></i>
															  	</span>
											</button>
										</td>
										<td>
											<small title={notFoundLabel.label.labelCollection.identifier}>{notFoundLabel.label.labelCollection.identifier.split(':').splice(-1)}</small>
										</td>
										<td>{notFoundLabel.label.name}</td>
										<td>{notFoundLabel.label.defaultValue}</td>
										{_.map(data.project.languages, (language, key) => {
											let value = '';
											_.map(notFoundLabel.label.translations, (translation) => {
												if (translation.labelcollectionlanguage.language.identifier === language.identifier) {
													value = translation.value;
												}
											});
											return (<td key={key}>{value}</td>)
										})}
									</tr>
								)
							}
						})}
						</tbody>
					</table>
				</div>
				<div>
					<ImportButton
						text={"Delete Labels"}
						data={data}
						isDisabled={status.project.codeScan.isRunning}
						labelsToImport={this.state.selectedLabels}
						isScannedLabels={false}
						selectedProject={this.props.selectedProject}
						afterImportCallback={() => {this.setState({selectedLabels : []})}}
					/>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./React/src/components/CodeScanner/NotFoundLabels.js